<template>
    <!--        <my-select :options="mydata" value="1" placeholder="Placeholder works!!!"></my-select>-->
    <!--            <v-select :options="regions" label="name" class="form-control"></v-select>-->



    <form action="" class="sky-form" method="post"
          @submit.prevent="validate">
        <fieldset class="no-padding">

<!--            <p-->
<!--              v-for="error of v$.$errors"-->
<!--              :key="error.$uid"-->
<!--            >-->
<!--            <strong>{{ error.$validator }}</strong>-->
<!--            <small> on property</small>-->
<!--            <strong>{{ error.$property }}</strong>-->
<!--            <small> says:</small>-->
<!--            <strong>{{ error.$message }}</strong>-->
<!--            </p>-->

            <section>
                <div class="row" style="margin-bottom: 6px">
                    <div class="col-sm-6">
                        <label class="label">Регион <span class="text-danger">*</span></label>
                        <label class="select">
                            <select name="region_id" v-model="formData.region_id" @change="updateCities">
                                <option value="">Выберите регион</option>
                                <option v-for="region in regions" :value="region.id"> {{ region.name }}</option>
                            </select>
                            <i></i>
                        </label>

                        <form-error for="formData.region_id"></form-error>

                    </div>
                    <div class="col-sm-6">
                        <label class="label">Город <span class="text-danger">*</span></label>
                        <label class="select">
                            <select name="city_id" v-model="formData.city_id">
                                <option value="">Выберите город</option>
                                <option v-for="city in cities" :value="city.id"> {{ city.name }}</option>
                            </select>
                            <i></i>
                        </label>

                        <form-error for="formData.city_id"></form-error>
                    </div>
                </div>

                <div class="row" style="margin-bottom: 6px">
                    <div class="col-sm-12">
                        <label class="label">Что необходимо{{ type==='service'?' обслужить':''}}: <span class="text-danger">*</span></label>
                        <label class="select">
                            <v-select label="name_rent_general"
                                      v-model="formData.machinery_type_id"
                                      placeholder="Введите запрос. (Примеры: Экскаватор, минипогрузчик, говновоз)"
                                      :filterable="false"
                                      :reduce="type => type.id"
                                      :options="types"
                                      :append-to-body="true"
                                      @search="onSearch">
                                <template slot="no-options">

                                    Ничего не найдено. Попробуйте сформулировать иначе

                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <img :src='"/images/machinery_icons/"+option.id + ".jpg"'
                                             style="width:60px; margin-right: 5px"/>
                                        <span>
                                    {{ type === 'rent' ? option.name_rent_general : option.name_sale_general }} <br>
                                     <span style="color:blue">
                                         {{
                                             type === 'rent' ? option.bref_note_rent : option.bref_note_sale
                                         }}
                                     </span>

                                </span>

                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ type === 'rent' ? option.name_rent_general : option.name_sale_general }}
                                    </div>
                                </template>
                            </v-select>
                        </label>

                        <form-error for="formData.machinery_type_id"></form-error>
                    </div>
                </div>

                <div class="row" v-if="parameter_for_request && formData.machinery_type_id" style="margin-bottom: 6px">
                    <div class="col-sm-12">

                        <label class="label">{{ parameter_for_request.name }} <span class="text-danger">*</span></label>
                        <label class="select">
                            <select v-model="formData.machinery_parameter_value">
                                <option value="">Выберите значение</option>
                                <option v-for="option in parameter_for_request.extra_serialized" :value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                            <i></i>
                        </label>

                        <form-error for="formData.machinery_parameter_value"/>

                    </div>
                </div>



                <div class="row"  v-if=" ! auth_user">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <div class="form-group">
                                <label class="label">Ваше имя (Название организаци) <span class="text-danger">*</span></label>
                                <label class="input">
                                    <i class="icon-append fa fa-user"></i>
                                    <input type="text" name="contact_name" placeholder=""
                                           v-model="formData.contact_name">
                                    <b class="tooltip tooltip-bottom-right">Как мы можем к вам обращаться?</b>
                                </label>
                                <form-error for="formData.contact_name" />

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">

                            <label for="phone1" class="label">Телефон<span class="text-danger">*</span></label>
                            <label class="input">
                                <i class="icon-append fa fa-phone"></i>

<!--                                <the-mask id="phone1"-->
<!--                                          mask="+7 ###-###-####"-->
<!--                                          type="tel" placeholder="Телефон"-->
<!--                                          v-model="formData.contact_phone">-->
<!--                                </the-mask>                                -->

                                <smart-phone-field id="phone1"
                                          v-model="formData.contact_phone">
                                </smart-phone-field>

                                <i></i>
                            </label>

                            <form-error for="formData.contact_phone" />

                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-sm-6" v-if="type === 'rent'">
                        <div class="form-group">

                            <label class="label">Дата аренды <span class="text-danger">*</span></label>
                            <label class="select">
                                <select v-model="formData.request_date_type">
                                    <option value="A">В любое время</option>
                                    <option value="P">В период с... по...</option>
                                    <option value="C">Указать дату</option>
                                    <option value="B">Не позднее чем</option>
                                </select>
                                <i></i>
                            </label>

                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">

                            <label class="label">Способ оплаты <span class="text-danger">*</span></label>
                            <label class="select">
                                <select v-model="formData.payment_method">
                                    <option value="">Выберите</option>
                                    <option value="1">Только наличный расчет</option>
                                    <option value="2">Только безналичный расчет</option>
                                    <option value="3">Наличный или безналичный</option>
                                </select>
                                <i></i>
                            </label>

                            <form-error for="formData.payment_method" />
                        </div>
                    </div>

                    <div class="col-sm-6" v-if="type==='service'">
                        <label class="label">Вид работ <span class="text-danger">*</span></label>
                        <label class="select">
                            <select name="city_id" v-model="formData.work_type_id">
                                <option value="">Тип работ</option>
                                <option v-for="type in workTypes" :value="type.id"> {{ type.name }}</option>
                            </select>
                            <i></i>
                        </label>

                        <form-error for="formData.work_type_id"></form-error>
                    </div>

                </div>

            </section>
            <hr>
            <section>
                <div class="row" v-if='formData.request_date_type != "A"'>
                    <section class="col-sm-6">
                        <div class="form-group">
                            <label class="label">Дата начала работ</label>
                            <label class="input">
                                <i class="icon-append fa fa-calendar"></i>
                                <date-picker v-model="formData.date1" valueType="format"></date-picker>
                                <b class="tooltip tooltip-bottom-right">Когда будут производиться работы?</b>
                            </label>

                            <form-error for="formData.date1" />


                        </div>
                    </section>
                    <section class="col-sm-6" v-if="formData.request_date_type == 'P'">
                        <div class="form-group">

                            <label class="label">Дата окончания работ</label>
                            <label class="input">
                                <i class="icon-append fa fa-calendar"></i>
                                <date-picker v-model="formData.date2" valueType="format"></date-picker>
                                <b class="tooltip tooltip-bottom-right">Когда работы будут закончены?</b>
                            </label>

                             <form-error for="formData.date2" />
                        </div>
                    </section>
                </div>
                <div class="row" v-if="type==='rent'">
                    <section class="col-sm-12">
                        <div class="form-group">
                            <label class="label">Место работ (адрес, местоположение, координаты)</label>
                            <label class="input">
                                <i class="icon-append fa fa-map-marker"></i>
                                <input type="text" v-model="formData.location" placeholder="">
                                <b class="tooltip tooltip-bottom-right">Где будут производиться работы?</b>
                            </label>
                        </div>
                    </section>
                </div>
                <div class="row">
                    <section class="col-sm-12">
                        <label class="textarea">

                            <textarea rows="3" v-model="formData.offer"
                                      :placeholder="type==='rent' ? 'Укажите объем работ и дополнительную информацию' :
                                                                    'Укажите дополнительную информацию'">
                            </textarea>
                        </label>
                    </section>
                </div>
            </section>
            <section>
                <div class="row">
                    <div class="col-md-6">

                        <vue-recaptcha ref="recaptcha"
                                       :sitekey="site_key"
                                       @verify="captcha"
                                       @expired="onCaptchaExpired"
                        />

                        <form-error for="captcha_token"/>


                    </div>
                </div>
            </section>
            <section>
                <div class="row">
                    <div class="col-md-8">

                    </div>
                    <div class="col-md-4">
                        <button class="btn btn-alt btn-icon btn-icon-right btn-icon-go pull-right" type="submit">
                            <span>Отправить заявку</span>
                        </button>
                    </div>
                </div>
            </section>
        </fieldset>
    </form>


</template>

<script>


import vSelect from "vue-select";
import VueRecaptcha from "vue-recaptcha";
import { TheMask } from "vue-the-mask";
import debounce from "lodash/debounce";
import 'vue-select/dist/vue-select.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

import useVuelidate from '@vuelidate/core'

import {required} from "../helpers/ru-validators";
import FormError from "./elements/FormError";
import SmartPhoneField from "./elements/SmartPhoneField";
import {ref} from "@vue/composition-api";

export default {
    name: "RentRequest",
    components: {SmartPhoneField, vSelect, VueRecaptcha, TheMask, DatePicker, FormError },
    props: {
        type: {
            default: 'rent',
            type:String
        },
        region_id: {
            default: '',
            required: false
        },
        city_id: {
            default: '',
            required: false
        },
        machinery_type_id: {
            default: null,
            type: Number,
            required: false
        },
        auth_user: {
            type: Boolean,
            default: false
        },


    },
    setup() {
            const externalResults =  ref({
                formData: {
                    machinery_type_id: null
                }
            });

            return {
               externalResults,
               v$: useVuelidate({ $externalResults: externalResults, $autoDirty: true })
               // v$: useVuelidate()
            }


    },
    data: function () {
        return {
            formData: {},
            regions: [],
            cities: [],
            types: [],
            workTypes: [],
            parameter_for_request: null,
            site_key: '6LemS_MZAAAAALrqs1w85oz4UaPcCJ5GcRVOSWyO',
            captcha_token: null,
        }
    },
    watch: {
        // "formData.region_id": function () {
        //     // console.log("formData.region_id")
        //     // this.getCities();
        //     // this.formData.city_id = '';
        // },
        "formData.machinery_type_id": function () {
            this.formData.machinery_parameter_id = null;
            this.formData.machinery_parameter_value = ''
            this.parameter_for_request = null;
            this.getParameter();
        }
    },
    methods: {
        captcha: function (token) {
            this.captcha_token = token;
        },
        onCaptchaExpired: function () {
            this.captcha_token = null;
        },
        getRegions: function () {
            axios.get('/api/location/regions').then(result => {
                this.regions = result.data;
            });
        },
        getCities: function () {

            if (this.formData.region_id) {
                axios.get('/api/location/cities/0/' + this.formData.region_id).then(response => {
                    this.cities = response.data;
                })

            }
        },
        getType: function () {

            if (this.machinery_type_id) {

                axios.get('/api/type/' + this.machinery_type_id).then(response => {
                    this.types.push(response.data);
                });

            }
        },
        getParameter: function () {
             if (this.formData.machinery_type_id) {

                    axios.get('/api/parameter_for_request/' + this.formData.machinery_type_id).then(
                    response => {
                        if (Object.keys(response.data).length) {
                            this.parameter_for_request = response.data;
                            this.formData.machinery_parameter_id = response.data.id;
                        }

                    }
                );
             }

        },
        getWorkTypes: function (){

            if (this.type === 'service') {
                axios.get('/api/work_types').then (response => {
                    this.workTypes = response.data;
                });

            }

        },
        updateCities () {
            this.getCities();
            this.formData.city_id = '';
        },

        onSearch(search, loading) {
            if (search.length) {

                loading(true);
                this.search(loading, search, this);

            }
        },
        search: debounce((loading, search, vm) => {

            axios.get('/api/type/search/' + search).then(response => {
                vm.types = response.data.result

                loading(false);
            });

        }, 1000),
        async validate() {

            const isFormCorrect =  await this.v$.$validate();

            if (! isFormCorrect) return;

            this.formData.captcha_token = this.captcha_token;
            this.formData.type = this.type;

            axios.post('/api/service-request/', this.formData).then(response => {

                 this.$swal('Спасибо за обращение!', 'Ваша заявка поступила в работу').then(function(){
                      window.location = response.data.redirect;
                     //history.back();
                 });


            }).catch(error => {

                if (error.response){
                    Object.assign(this.externalResults.formData, error.response.data.errors);
                }
            });


        }

    },
    validations() {

        const baseRules = {
            formData: {
                region_id: {required},
                city_id: {required},
                machinery_type_id: {required},
                payment_method: {required},

            },
            captcha_token: {required}
        };

        if (this.parameter_for_request && this.formData.machinery_type_id) {
            baseRules.formData.machinery_parameter_value = {required}
        }

        if ( ! this.auth_user){
            baseRules.formData.contact_phone = {required};
            baseRules.formData.contact_name = {required};

        }

        if (this.type === 'service') {
            baseRules.formData.work_type_id = {required};
        }

        if (this.formData.request_date_type != "A") {

            baseRules.formData.date1 = {required};

             if (this.formData.request_date_type === "P") {
                 baseRules.formData.date2 = {required};
             }

        }

        return baseRules;
    }

    ,
    created() {
        this.getRegions();

        this.getType();
        this.getParameter();

        this.formData = {

            region_id: this.region_id,
            city_id: this.city_id,
            machinery_type_id: this.machinery_type_id,
            request_date_type: "A",
            payment_method: "",
            machinery_parameter_value: "",
            work_type_id: "",
            contact_phone: "",
        }

        this.getCities();
        this.getWorkTypes();

    }
}
</script>

<style lang="scss" scoped>
//@import 'vue-select/dist/vue-select.css'
</style>

<!--{-->
<!--"message":"The given data was invalid.",-->
<!--"errors":-->
<!--{"city_id":["Erorr text"]-->
<!--}-->
<!--}-->
